import ImportFileMenuItem from "./components/ImportFileMenuItem"

export default {
  components: {
    ImportFileMenuItem
  }
}


// WEBPACK FOOTER //
// ./src/standalone/topbar-menu-file-import_file/index.js